import { render, staticRenderFns } from "./AddressVerification.vue?vue&type=template&id=257e5991&"
import script from "./AddressVerification.vue?vue&type=script&lang=js&"
export * from "./AddressVerification.vue?vue&type=script&lang=js&"
import style0 from "./AddressVerification.vue?vue&type=style&index=0&id=257e5991&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports